import { useSelector } from 'react-redux';
import { selectUser } from '../redux/reducers/userReducer';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useLogoutRedirectionHome = () => {
  const user = useSelector(selectUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user.data?.user.user_id && !localStorage.getItem('user_email')) {
      navigate('/');
    }
    return () => {};
  }, [user.data?.user.user_id]);
};
